import React, { useEffect, useState } from 'react';
import { AgentTypes, AvailableNodes, ModelType, NodeType, TemplateStatus } from '../../../../helper/constant';
import { useAIModelContext } from '../../../../context/ai-model.context';
import { useAIWorkflowContext } from '../../../../context/ai-workflow.context';
import { Handle } from '@xyflow/react';
import { renderNodeIcon } from '../../../../helper/helper';
import { Link, useParams } from 'react-router-dom';
import NodePrediction from '../components/NodePrediction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faMicrochip } from '@fortawesome/free-solid-svg-icons';
import NodeStatus from '../components/NodeStatus';
import { NodeDeleteButton } from './InputNode';
import { getWorkflowExecutionResultAPI } from '../../../../service/ai-model.service';
import GenerativePrediction from '../components/GenerativePrediction';
import CustomLoader from '../../../common/CustomLoader';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const AgentNode = ({ data, id, workflow }) => {
    const { updateRightMenu, updatePredictionModel } = useAIModelContext();
    const { updateSelecteNode, workflowExecution, workflowEdit } = useAIWorkflowContext();
    const params = useParams();
    const [showModal, setShowModal] = useState(false);
    const [generativeData, setGenerativeData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!showModal) {
            setGenerativeData(null);
        }
    }, [showModal]);


    const handleNodeClick = () => {
        updateRightMenu(true);
        updateSelecteNode({ id, data })
    };

    const onShowPrediction = (e) => {
        e.stopPropagation();
        if (data && data.agentType === AgentTypes[0].id) {
            let device = '';
            let zone = '';
            let sensor = '';
            if (data.modelId === ModelType.SensorLogger) {
                const inputNode = workflow.initialNodes.filter(i => i.type === NodeType.InputNode);
                if (inputNode.length) {
                    device = inputNode[0].data.device;
                    sensor = inputNode[0].data.sensor;
                    zone = inputNode[0].data.zone;
                }
            }
            const model = {
                model_name: data.label,
                taskId: data.taskId,
                modelId: data.modelId,
                templateId: data.templateId,
                deviceId: device,
                zone,
                sensor
            };
            updatePredictionModel({ ...model });
        } else {
            const payload = {
                "nodeId": id,
                "executionId": workflowExecution?.executionId
            }
            setLoading(true);
            getWorkflowExecutionResultAPI(payload)
                .then((res) => {
                    if (res && res.length) {
                        const data = res[res.length - 1];
                        setGenerativeData(data);
                    } else {
                        setGenerativeData(null)
                    }
                }).catch((err) => setGenerativeData(null)
                ).finally(() => {
                    setLoading(false)
                    setShowModal(true);
                });
        }
    }

    const renderViewResults = () => {
        if (workflow && workflow.status === TemplateStatus.COMPLETED && workflowExecution && workflowExecution.executionId) {
            const tooltipResult = (
                <Tooltip className='agent-tooltip'>
                    Show Agent Result
                </Tooltip>
            );
            return (<OverlayTrigger placement="top" overlay={tooltipResult}>
                <Link
                    onClick={onShowPrediction}
                    className='align-self-center fs-10'>{<FontAwesomeIcon icon={faEye} />} View</Link>
            </OverlayTrigger>)
        }
    }

    const renderNodeDetails = () => {
        if (data && data.name) {
            return (
                <div className='d-flex flex-column pb-2'>
                    <div className='px-2 pb-2 node-details'>
                        <p className='p-0 m-0 text-black'>Node: <span className='text-secondary'>{data.agentName}</span></p>
                        {data.agentType && <p className='p-0 m-0 text-black'>Type: <span className='text-secondary'>{data.agentType}</span></p>}
                        <p className='p-0 m-0 text-black'>Agent: <span className='text-secondary'>{data.model}</span></p>
                    </div>
                    {renderViewResults()}
                </div>
            )
        }
    }

    const renderNodePrediction = () => {
        return <NodePrediction id={id} templateId={data.templateId} workflowId={params.id} />
    }

    const renderNodeGenerative = () => {
        if (generativeData) {
            return (
                <GenerativePrediction
                    id={id}
                    name={data.model}
                    executionId={workflowExecution.executionId}
                    data={generativeData}
                    showModal={showModal}
                    setShowModal={setShowModal} />
            )
        }
    }

    const renderDeleteButton = () => {
        if (workflowEdit)
            return <NodeDeleteButton id={id} />
    }

    const render = () => {
        const tool = (<Tooltip className='agent-tooltip'>Research Agent</Tooltip>)
        if (data) {
            return (
                <>
                    <div className={`dndnode d-flex flex-column gap-1 input ${NodeType.AgentNode} `} onClick={handleNodeClick}>
                        {renderDeleteButton()}
                        {data &&
                            <div className='p-2 m-0 node-title d-flex justify-content-between align-items-center' style={{ backgroundColor: AvailableNodes[1].color }}>
                                <div className='d-flex align-items-center'>
                                    {renderNodeIcon(data.type, 25)}
                                    <p className='p-0 m-0'>
                                        <span>{data.agentName || data.model || data.label}</span>
                                        {data.agent_type === 'RESEARCH' && <span className='ml-1'>
                                            <OverlayTrigger placement="top" overlay={tool}><FontAwesomeIcon icon={faMicrochip} className="text-default" /></OverlayTrigger>
                                        </span>
                                        }
                                    </p>
                                </div>
                                {workflow.status === TemplateStatus.COMPLETED && <NodeStatus id={id} name={workflow.name} />}
                            </div>
                        }
                        {renderNodeDetails()}
                        <Handle
                            type="target"
                            position="left"
                            style={{ background: '#555' }}
                            id={`${id}-target`}
                            isConnectable={true}
                        />
                        <Handle
                            type="source"
                            position="right"
                            style={{ background: '#555' }}
                            id={`${id}-source`}
                            isConnectable={true}
                        />
                    </div>
                    {renderNodePrediction()}
                    {renderNodeGenerative()}
                    {loading && <CustomLoader full small />}
                </>
            )
        }
    }
    return render();
}

export default AgentNode